<template>
  <section class="backBoxSetting">
    <!-- start of navbar design -->
    <Navbar />
    <!-- end of navbar design -->

    <!-- two columns (for side menu) -->

    <div class="topSettingInfo">
      <div class="topLeft">
        <div class="profileImage">
          <img
            class="profilePicItself"
            :src="this.profile.profileImage"
            alt="profile Image"
          />
        </div>
        <div class="profileSettingColumn">
          <p v-if="this.profile" class="settingNameDesign">
            {{ this.profile.firstName }} {{ this.profile.lastName }}
          </p>
          <p class="settingUniNameDesign" v-if="this.school">
            {{ this.school }}
          </p>
          <router-link
            class="toProfileButton"
            :to="{
              name: 'Profile',
              params: { schoolName: this.user.schoolName },
            }"
          >
            View profile
          </router-link>
        </div>
      </div>
      <div
        class="topAmbassadorColumn rightAlign"
        id="selectTotalReferrals"
        @click="goToPortal"
      >
        <p class="boldTitleSmall">
          Total referrals
        </p>
        <p class="boldTitleBig">
          {{ numReferrals }}
        </p>
      </div>
    </div>
    <div class="settingsBox">
      <span id="settingMessage">{{ settingFeedback }}</span>
      <div class="settingRow">
        <img
          class="settingIcon makeSmall"
          src="@/assets/settingAssets/settingName.svg"
          @click="editName()"
        />
        <div class="settingTitle" @click="editName()">Name</div>
        <div class="settingText">
          <p v-if="!isEditingName" @click="editName()">
            {{ this.profile.firstName }} {{ this.profile.lastName }}
          </p>
          <input
            v-if="isEditingName"
            class="names"
            type="text"
            name="newCode"
            v-model="firstName"
          />
          <input
            v-if="isEditingName"
            class="names"
            type="text"
            name="newCode"
            v-model="lastName"
          />
        </div>
        <div v-if="!isEditingName" class="settingButton" @click="editName()">
          Edit
        </div>
        <div v-if="isEditingName" class="editSetting" @click="saveName()">
          Save
        </div>
        <div v-if="isEditingName" class="editSetting" @click="cancelName()">
          Cancel
        </div>
      </div>
      <div
        class="settingRow"
        @click="copySetting('email')"
        v-clipboard:copy="this.email"
      >
        <img
          class="settingIcon"
          src="@/assets/settingAssets/settingEmail.svg"
        />
        <div class="settingTitle">Email</div>
        <div class="settingText">
          {{ this.email }}
        </div>
        <div class="settingButton">Copy</div>
      </div>
      <div
        class="settingRow"
        @click="copySetting('link')"
        v-clipboard:copy="this.shareLink"
      >
        <img class="settingIcon" src="@/assets/settingAssets/settingLink.svg" />
        <div class="settingTitle">Share link</div>
        <div class="settingText">courselnk.com/{{ user.id }}</div>
        <div class="settingButton">Share</div>
      </div>
      <div class="settingRow" @click="copySetting('code')">
        <img
          class="settingIcon makeSmall"
          src="@/assets/settingAssets/settingCode.svg"
        />
        <div class="settingTitle">Referral Code</div>
        <div class="settingText">{{ aCode }}</div>
        <div class="settingButton">Share</div>
      </div>
      <div
        class="settingRow"
        @click="copySetting('profile')"
        v-clipboard:copy="this.shareProfile"
      >
        <img
          class="settingIcon makeSmall"
          src="@/assets/settingAssets/settingProfile.svg"
        />
        <div class="settingTitle">Share Profile</div>
        <div class="settingText">
          {{ this.shareProfile }}
        </div>
        <div class="settingButton">Share</div>
      </div>
      <div
        class="settingRow"
        @click="copySetting('password')"
        @click.prevent="resetPassword()"
      >
        <img
          class="settingIcon"
          src="@/assets/settingAssets/settingPassword.svg"
        />
        <div class="settingTitle">Password</div>
        <div class="settingText">••••••</div>
        <div class="settingButton">Edit</div>
      </div>
      <div class="settingRow" @click.prevent="logoutClicked">
        <img
          class="settingIcon makeSmall"
          src="@/assets/settingAssets/settingLogout.svg"
        />
        <div class="settingTitle">Logout</div>
        <div class="settingText"></div>
        <div class="settingButton">Logout</div>
      </div>
    </div>

    <p class="frame">
      Every time someone signs up with your referral code or share link you both
      get another entry into a draw to win multiple $50 Uber Eats gift cards!
    </p>

    <!--
    <div class="midTopProfile container is-fluid postContainer">
      <div v-for="(post, index) in clippedPosts" :key="index">
        <ClippedPost
          :post="post"
          :index="index"
          :currentUser="currentUser"
          @addClip="addClip"
          @openGallery="openGallery"
        />
      </div>
      <div v-if="clippedPosts.length == 0" style="margin-top: 10px">
        <img src="@/assets/Component 624.png" />
      </div>
    </div>
    -->

    <LightBox ref="lightbox" :media="media" :show-light-box="false" />
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import { mapState, mapActions } from "vuex";
import db from "@/db";
import firebase from "@/firebase";
//import ClippedPost from "@/components/ClippedPost";
import LightBox from "vue-image-lightbox";
import Navbar from "@/components/Navbar";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

export default {
  components: {
    //ClippedPost,
    LightBox,
    Navbar,
  },
  data: () => ({
    media: [], //Clickable images in a post
    profile: [],
    email: null,
    school: null,
    isAmbassador: false,
    isEditingName: false,
    previousFirst: "",
    previousLast: "",
    changedPassword: false,
    clips: 0,
    clippedPostIds: [],
    clippedPosts: [],
    isShowingClippedPosts: false,
    currentUser: null,
    settingFeedback: "",
    numReferrals: 0,
    shareLink: "courselnk.com/",
    shareProfile: "courselnk.com/profile/",
    aCode: "",

    //Drop zone options
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      thumbnailHeight: 150,
      maxFilesize: 5,
      maxFiles: 10,
      duplicateCheck: true,
      addRemoveLinks: true,
      dictDefaultMessage: "Edit Image",
      previewsContainer: false,
    },
  }),

  mounted() {
    this.currentUser = this.user;

    this.getLink();

    this.initProfile(); //Gets all the users Groups
    this.findReferralNum();
  },

  computed: {
    ...mapState("user", ["user"]),
  },
  methods: {
    ...mapActions("user", ["logout"]),

    // async personal() {
    //   db.collection("users")
    //     .where("course_id", "==", "NcZfa5GYSOPCWk3J6v6g")
    //     .limit(1)
    //     .get()
    //     .then(function (querySnapshot) {
    //       querySnapshot.forEach(function (doc) {
    //         console.log(doc.data, "data");
    //         doc.ref.delete();
    //       });
    //     });
    // },

    logoutClicked() {
      this.logout();
      this.$router.push({ name: "Login" });
    },

    goToPortal() {
      if (this.isAmbassador) {
        this.$router.push({
          name: "Portal",
        });
      }
    },
    async addUsersToMain() {
      db.collection("users")
        .where("school_id", "==", "5Uo24jSg4nGg3sVOzeec")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            var groups = doc.data().groups;
            groups.push({
              group_id: "NcZfa5GYSOPCWk3J6v6g",
              notificationsEnabled: true,
              name: "McGill",
              hasUnReadPosts: false,
            });
            db.collection("groups")
              .doc("NcZfa5GYSOPCWk3J6v6g")
              .update({
                userCount: firebase.firestore.FieldValue.increment(1),
              });
            db.collection("users")
              .doc(doc.id)
              .update({
                groups: groups,
                group_ids: firebase.firestore.FieldValue.arrayUnion(
                  "NcZfa5GYSOPCWk3J6v6g"
                ),
              });
          });
        });
    },

    async initProfile() {
      await db
        .collection("users")
        .doc(this.currentUser.id)
        .get()
        .then((doc) => {
          this.profile = doc.data();
          this.firstName = doc.data().firstName;
          this.lastName = doc.data().lastName;
          this.clips = doc.data().totalClips;
          this.clippedPostIds = doc.data().clips;
          db.collection("schools")
            .doc(doc.data().school_id)
            .get()
            .then((doc) => {
              this.school = doc.data().name;
            });
        });
      this.email = firebase.auth().currentUser.email;
    },

    async fetchClippedPosts() {
      // db.collection("users")
      //   .where("school_id", "==", "pOFdIKe2KVcQ8IbEl6sw")
      //   .get()
      //   .then((docs) => {
      //     docs.forEach((doc) => {
      //       const object = doc.data();
      //       object.objectID = doc.id;
      //       index.saveObject(object);
      //     });
      //   });
      // if (this.clippedPosts.length == 0) {
      //   for (const index in this.clippedPostIds) {
      //     await db
      //       .collection("posts")
      //       .doc(this.clippedPostIds[index])
      //       .get()
      //       .then((doc) => {
      //         this.clippedPosts.push(doc.data());
      //       });
      //   }
      // }
      // this.isShowingClippedPosts = !this.isShowingClippedPosts;
    },

    async findReferralNum() {
      await db
        .collection("ambassadorInfo")
        .doc(this.currentUser.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.numReferrals += doc.data().referralIds.length;
            this.aCode = doc.data().referralCode;
            this.isAmbassador = true;
          }
        });

      this.numReferrals += this.currentUser.numReferrals;
    },

    getLink() {
      this.shareLink = this.shareLink.concat(this.currentUser.id);
      this.shareProfile = this.shareProfile.concat(this.currentUser.firstName);
      this.shareProfile = this.shareProfile.concat("-");
      this.shareProfile = this.shareProfile.concat(this.currentUser.lastName);
      //ARITRA uncomment the following two lines
      //this.shareProfile = this.shareProfile.concat("/");
      //this.shareProfile = this.shareProfile.concat(this.currentUser.id);
      this.aCode = firebase.auth().currentUser.email;
    },

    async editName() {
      if (!this.isEditingName) {
        this.isEditingName = true;
        this.previousFirst = this.firstName;
        this.previousLast = this.lastName;
      }
    },
    async cancelName() {
      this.isEditingName = false;
      this.firstName = this.previousFirst;
      this.lastName = this.previousLast;
    },
    async saveName() {
      if (this.firstName.length > 0 && this.lastName.length > 0) {
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            firstName: this.firstName,
            lastName: this.lastName,
          });
        this.profile.firstName = this.firstName;
        this.profile.lastName = this.lastName;

        this.isEditingName = false;
      } else if (this.firstName.length == 0) {
        this.copySetting("first");
      } else {
        this.copySetting("last");
      }
    },

    async setImage(file) {
      const storageRef = firebase.storage().ref();

      // If is an image
      if (file["type"] === "image/jpeg" || file["type"] === "image/png") {
        const fileRef = storageRef.child(`profileImages/${file.name}.png`);
        await fileRef.put(file);
        const downloadURL = await fileRef.getDownloadURL();
        await db
          .collection("users")
          .doc(firebase.auth().currentUser.uid)
          .update({
            profileImage: downloadURL,
          });

        this.profile.profileImage = downloadURL;
      }
    },
    resetPassword() {
      var auth = firebase.auth();
      var emailAddress = this.email;

      auth
        .sendPasswordResetEmail(emailAddress)
        .then(() => {
          this.changedPassword = true;
        })
        .catch(() => {
          this.feedback = "The email entered is not valid";
        });
    },

    openGallery(index, files) {
      this.media = [];
      for (const file in files) {
        const fi = {
          thumb: files[file].src,
          src: files[file].src,
        };
        this.media.push(fi);
      }
      this.$refs.lightbox.showImage(index);
    },

    copySetting(command) {
      var timeOut = 1500;
      if (command == "email") {
        this.settingFeedback = "Copied email!";
      } else if (command == "link") {
        this.settingFeedback = "Copied share link!";
      } else if (command == "code") {
        this.settingFeedback = "Copied referral code!";
      } else if (command == "profile") {
        this.settingFeedback = "Copied profile link!";
      } else if (command == "password") {
        this.settingFeedback =
          "An email has been forwarded to your university email with instructions on how to change your password";
        timeOut = 5000;
      } else if (command == "first") {
        this.settingFeedback = "You must enter a first name";
      } else if (command == "last") {
        this.settingFeedback = "You must enter a last name";
      }

      document.getElementById("settingMessage").style.display = "flex";
      setTimeout(() => {
        document.getElementById("settingMessage").style.display = "none";
      }, timeOut);
    },

    async addClip(post, index) {
      var postsCollection = this.isFilter ? this.filteredPosts : this.posts;
      var alreadyClipped = false;
      db.collection("users")
        .doc(this.userId)
        .get()
        .then((doc) => {
          for (const clip in doc.data().clips) {
            //Checks if the user has already clipped the post
            if (doc.data().clips[clip] === post.id) {
              alreadyClipped = true;
            }
          }
          // If the user hasnt clipped the post then clip it else unclip it
          if (!alreadyClipped) {
            postsCollection[index].clips += 1;
            db.collection("posts")
              .doc(post.id)
              .update({
                clips: firebase.firestore.FieldValue.increment(1),
              });
            db.collection("users")
              .doc(this.userId)
              .update({
                clips: firebase.firestore.FieldValue.arrayUnion(post.id),
              });

            db.collection("users")
              .doc(post.user_id)
              .update({
                totalClips: firebase.firestore.FieldValue.increment(1),
              });
          } else {
            postsCollection[index].clips -= 1;
            db.collection("posts")
              .doc(post.id)
              .update({
                clips: firebase.firestore.FieldValue.increment(-1),
              });
            db.collection("users")
              .doc(this.userId)
              .update({
                clips: firebase.firestore.FieldValue.arrayRemove(post.id),
              });
            db.collection("users")
              .doc(post.user_id)
              .update({
                totalClips: firebase.firestore.FieldValue.increment(-1),
              });
          }
        });
    },
  },
};
</script>

<style src="@/styles/views/Settings.css"></style>
